import React from "react";

import { TbCurrencyTaka } from "react-icons/tb";
import { HiUserGroup } from "react-icons/hi";
import { MdDoubleArrow } from "react-icons/md";
import { AiFillSchedule } from "react-icons/ai";
import { TiTick } from "react-icons/ti";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import UseTitle from "../../Hooks/UseTitle";
import roomCover from "../../../Assets/Hompage/deluxe/deluxe.jpg";
import roomCoverMobile from "../../../Assets/Hompage/deluxe/deluxe1 (1).jpg";
import deluxe1 from "../../../Assets/Hompage/deluxe/deluxe1 (1).jpg";
import deluxe2 from "../../../Assets/Hompage/deluxe/deluxe1 (2).jpg";
import deluxe3 from "../../../Assets/Hompage/deluxe/deluxe1 (3).jpg";
import deluxe4 from "../../../Assets/Hompage/deluxe/deluxe1 (4).jpg";
import { Link } from "react-router-dom";

const Deluxe = () => {
  UseTitle("Deluxe Room");
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="bg-gray-100">
      <div className="md:block hidden">
        <img src={roomCover} alt="Deluxe Room" className="w-full" />
      </div>
      <div className="md:hidden block">
        <img src={roomCoverMobile} alt="Deluxe Room" className="w-full" />
      </div>
      <div className="max-w-screen-xl mx-auto">
        <div className="py-10 md:px-20 px-5 bg-white">
          <h2 className="text-[50px] text-gray-800 text-center md:text-start">
            Deluxe{" "}
          </h2>
          <div className="pt-8 gap-5 md:gap-10 place-items-center md:place-items-start grid grid-cols-1 md:grid-cols-2">
            <div>
              <p className="flex text-[16px] md:text-[20px] gap-5 items-center">
                <span>
                  <TbCurrencyTaka />
                </span>
                <span>BDT 9,000++</span>
              </p>
            </div>
            <div>
              <p className="flex  md:text-[20px] gap-5 md:gap-10 items-center">
                <span>
                  <HiUserGroup />
                </span>
                <span>Occupancy</span>
                <span className="text-[14px] md:text[20px]">
                  Up to 2 adults and 2 kids.
                </span>
              </p>
            </div>
          </div>
          <div className="py-20">
            <p className="text-[16px]">
              A luxurious bedroom perfect for family & friends with the
              surrounding view of soothing nature and a heart-melting lake.
              Located on the lower floor of the Villas, our rooms boast
              king-sized beds facing toward the balcony. The balcony itself is
              open-air, providing a perfect spot to relax and enjoy the stunning
              view. Additionally, it has a porch, and the balcony gives direct
              access to the garden
            </p>
          </div>
        </div>

        <div className="px-5 md:px-0">
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlaySpeed={2000}
            autoPlay={true}
            customTransition="all .5"
          >
            <div>
              <img src={deluxe1} alt="deluxe" className="w-full" />
            </div>
            <div>
              <img src={deluxe2} alt="deluxe" className="w-full" />
            </div>

            <div>
              <img src={deluxe3} alt="deluxe" className="w-full" />
            </div>
            <div>
              <img src={deluxe4} alt="deluxe" className="w-full" />
            </div>
          </Carousel>
        </div>
        <div className="py-20">
          <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
            <div className="flex justify-center items-start">
              <div>
                <h2 className="text-[45px] mb-10 text-center md:text-start">
                  Room Amenities
                </h2>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>300 Sft.</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>Occupancy for 2 adults and 2 kids.</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>One Bed Room, 1 Bath.</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>Master Bedroom with King Size Bed.</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>Large Bathroom.</span>
                </p>

                <div className="my-20">
                  <Link to="/Online_Booking">
                    <button
                      type="button"
                      className="hover:-translate-y-6 duration-300 text-white w-full text-[30px] bg-[#FF9119] hover:bg-[#FF9119]/80 focus:ring-4 focus:outline-none focus:ring-[#FF9119]/50 font-bold px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#FF9119]/80 dark:focus:ring-[#FF9119]/40 mr-2 mb-2"
                    >
                      <AiFillSchedule className="mr-5" />
                      Book Now
                    </button>
                  </Link>
                </div>
              </div>
            </div>

            <div>
              <div className="flex justify-center flex-col p-6 bg-white border border-gray-200 rounded-lg shadow-md roomsBg">
                <h2 className="text-[45px] mb-10 text-center">
                  Complimentary Benefits
                </h2>

                <div className="flex justify-center">
                  <div>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Welcome Drink</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Breakfast </span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Toiletries with room</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Swimming Pool</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Play Ground for different games</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Kids Zone </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deluxe;
